import MoreVertIcon from "@mui/icons-material/MoreVert";
import SearchIcon from "@mui/icons-material/Search";
import { Fab, Input, InputAdornment, InputBase } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Badge from "@mui/material/Badge";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { styled } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useHistory } from "react-router-dom";
import CsystemsMain from "../csystems/CsystemsMain";
import Errors from "../csystems/Errors/Errors";
import ServerInfoApi from "../services/API/ServerInfo.Api";
import About from "./About";
import Alerts from "./Alerts/Alerts";
import Aspen from "./Aspen";
import Availability from "./Availability";
import Communication from "./Communication";
import CustomerList from "./CustomerList";
import Dashboard from "./Dashboard";
import NewInstance from "./NewInstance/NewInstance";
import ServerInfo from "./ServerInfo";
import EverestMain from "./Everest/EverestMain";
import TargetMain from "./Target/TargetMain";
import { Popover } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  buttonSelected: {
    color: "white !important",
    border: "1px solid white !important",
    padding: "2px 10px !important",
    fontWeight: "bold !important",
    marginLeft: "5px !important",
  },
  buttonUnSelected: {
    color: "silver !important",
    padding: "2px 10px !important",
    border: "1px solid gray !important",
    marginLeft: "5px !important",
  },
}));

enum QueryTypes {
  Ideal = 0,
  Infinity = 1,
  ServerInfo = 2,
  Availiability = 3,
  Alerts = 4,
  About = 5,
  IdealCustomer = 7,
  InfinityCustomer = 8,
  Aspen = 9,
  Dashboard = 10,
  Admin = 11,
  Csystems = 12,
  Errors = 13,
  Communication = 14,
  Everest = 15,
  Target = 16
}

type Permission = {
  management: boolean;
  serverInfo: boolean;
  idealCustomer: boolean;
  infinityCustomer: boolean;
  errors: boolean;
};

let childSearch = "";
const CSIMain = () => {
  const classes = useStyles();
  const [queryType, SetQueryType] = React.useState(-1);
  const [searchdata, SetSearchdata] = useState("" as string);
  const [serialNumber, SetSerialNumber] = React.useState<number>(0);
  const [aspenAlerts, SetAspenAlerts] = React.useState<number>(0);
  const [username, SetUsername] = React.useState("" as any);
  const [anchorElMore, setAnchorElMore] = React.useState(null);
  const [showUserInfo, SetShowUserInfo] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [domainUser, setDomainUser] = useState([] as any);
  //const [domainUser, setDomainUser] = useState(CheckDomainUser);

  const [permissions, SetPermissions] = React.useState<Permission>({
    management: false,
    errors: false,
    serverInfo: true,
    idealCustomer: true,
    infinityCustomer: true,
  });

  const history = useHistory();

  function CheckDomainUser() {
    try{
      let user: any = localStorage.getItem("user");
      let obj = JSON.parse(user);
      //alert (obj.domainUser);
      //alert (obj.domainUser.userRoles);
      let obj1 = JSON.parse(obj.domainUser);
      setDomainUser(obj1)
    }
    catch(err){

    }

  }

  function ShowUserInfo(e: any) {
    //alert('ShowUserInfo');
    setAnchorEl(e.currentTarget);
    SetShowUserInfo(true);

    console.log('domainUser');
    console.log(domainUser);
  }

  const handleCustomerListCallBack = (
    serialNumber: number,
    queryType: number
  ) => {
    SetSerialNumber(serialNumber);
    if (queryType == QueryTypes.Ideal) {
      SetQueryType(QueryTypes.IdealCustomer);
    }
    if (queryType == QueryTypes.Infinity) {
      SetQueryType(QueryTypes.InfinityCustomer);
    }
  };

  function HandleMoreClick(e: any) {
    setAnchorElMore(e.currentTarget);
  }

  function HideMore() {
    setAnchorElMore(null);
  }

  useEffect(() => {
    const User = JSON.parse(localStorage.getItem("user") ?? "") as Permission;
    if (User != null) {
      const {
        management,
        errors,
        serverInfo,
        idealCustomer,
        infinityCustomer,
      } = User;
      SetPermissions({
        management,
        errors,
        serverInfo,
        idealCustomer,
        infinityCustomer,
      });
    }
    CheckDomainUser();
  }, []);

  useEffect(() => {
    let _queryType = 10;
    if (queryType == -1) {
      let search = window.location.search.toLowerCase();
      let params = new URLSearchParams(search);
      let xRequest = params.get("qtype");
      if (xRequest != null) {
        for (let item in QueryTypes) {
          if (
            QueryTypes[item].trim().toLowerCase() ==
            xRequest.trim().toLowerCase()
          ) {
            _queryType = Number(item);
            break;
          }
        }
      }
    }
    SetQueryType(_queryType);
  }, []);

  useEffect(() => {
    if (childSearch == "") {
      SetSearchdata("");
    }
    childSearch = "";
    let name = localStorage.getItem("username");
    if (name != null) {
      SetUsername(name);
    }

    for (let item in QueryTypes) {
      if (queryType == Number(item)) {
        window.history.pushState(
          "page2",
          "Title",
          "?Qtype=" + QueryTypes[item]
        );
      }
    }
  }, [queryType]);

  //----------------- useQuery for Data-Fetching -----------------//
  const { data } = useQuery(
    ["GetCsiAlerts"],
    () => ServerInfoApi.getCsiAlerts(),
    {
      initialData: {},
      refetchInterval: 1000 * 60 * 1, //1 min
      refetchIntervalInBackground: true,
    }
  );

  const Search = styled("div")(({ theme }) => ({
    border: "1px solid gray !important",
    position: "relative",
    padding: 0,
    height: "30px",
    "&:hover": {},
    marginLeft: 0,
    width: "100%",
  }));

  const SearchIconWrapper = styled("div")(({ theme }) => ({
    margin: 0,
    border: "0px solid silver",
    paddingLeft: "5px",
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "silver",
  }));

  const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: "inherit",
    "& .MuiInputBase-input": {
      paddingLeft: `calc(1em + ${theme.spacing(2)})`,
      transition: theme.transitions.create("width"),
      width: "100%",
      [theme.breakpoints.up("sm")]: {
        width: "12ch",
        "&:focus": {
          width: "20ch",
        },
      },
    },
  }));

  function OnLogoutClick() {
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    localStorage.removeItem("user");
    history.push("/login");
  }

  const DefaultSearch = (value: string) => {
    childSearch = value;
    SetSearchdata(value);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="static"
        style={{ backgroundColor: "#424949", borderBottom: "1px solid gold" }}
      >
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            CSI Cloud Dealers |
            {/* <span style={{ fontSize: "13px", border:"1px solid silver", backgroundColor:"gray", padding:"5px 7px", marginLeft:"7px", borderRadius:"10px", cursor:"pointer" }} onClick={(event: any) => ShowUserInfo(event)}> Hello {username} </span> */}
            <span style={{ fontSize: "13px", border:"1px solid silver", backgroundColor:"gray", padding:"5px 7px", marginLeft:"7px", borderRadius:"10px", cursor:"pointer" }} onClick={(event: any) => ShowUserInfo(event)}> Hello {domainUser.FullName} </span>
            
            
            {/* CSI Cloud Dealers */}
          </Typography>
          <Box>
            <table>
              <tr>
                <td>
                  {(queryType == QueryTypes.Ideal ||
                    queryType == QueryTypes.Infinity ||
                    queryType == QueryTypes.Everest ||
                    queryType == QueryTypes.Target) && (
                      <Input
                        onChange={(e) => SetSearchdata(e.target.value)}
                        value={searchdata}
                        style={{
                          border: "1px solid silver",
                          padding: "0px 10px",
                          color: "white",
                          width: "200px",
                        }}
                        placeholder="Search..."
                        id="input-with-icon-adornment"
                        startAdornment={
                          <InputAdornment
                            position="start"
                            style={{ color: "white" }}
                          >
                            <SearchIcon />
                          </InputAdornment>
                        }
                      />
                    )}
                </td>
                <td>
                  {(queryType > 11 || queryType == 5 || queryType == 3) && (
                    <Button variant="text" className={classes.buttonSelected}>
                      {QueryTypes[queryType].toString()}
                    </Button>
                  )}
                </td>

                <td>
                  <Button
                    variant="text"
                    onClick={(e: any) => {
                      SetQueryType(QueryTypes.Dashboard);
                    }}
                    className={
                      queryType == QueryTypes.Dashboard
                        ? classes.buttonSelected
                        : classes.buttonUnSelected
                    }
                  >
                    Dashboard
                  </Button>
                </td>

                {permissions.management && (
                  <td>
                    <Button
                      variant="text"
                      onClick={(e: any) => {
                        SetQueryType(QueryTypes.Admin);
                      }}
                      className={
                        queryType == QueryTypes.Admin
                          ? classes.buttonSelected
                          : classes.buttonUnSelected
                      }
                    >
                      Admin
                    </Button>
                  </td>
                )}

                {permissions.idealCustomer && (
                  <td>
                    <Button
                      variant="text"
                      onClick={(e: any) => {
                        SetQueryType(QueryTypes.Ideal);
                      }}
                      className={
                        queryType == QueryTypes.Ideal
                          ? classes.buttonSelected
                          : classes.buttonUnSelected
                      }
                    >
                      Ideal Customers
                    </Button>
                  </td>
                )}

                {permissions.infinityCustomer && (
                  <td>
                    <Button
                      variant="text"
                      onClick={(e: any) => {
                        SetQueryType(QueryTypes.Infinity);
                      }}
                      className={
                        queryType == QueryTypes.Infinity
                          ? classes.buttonSelected
                          : classes.buttonUnSelected
                      }
                    >
                      Infinity Customers
                    </Button>
                  </td>
                )}

                <td>
                  <Button
                    variant="text"
                    onClick={(e: any) => {
                      SetQueryType(QueryTypes.Aspen);
                    }}
                    className={
                      queryType == QueryTypes.Aspen
                        ? classes.buttonSelected
                        : classes.buttonUnSelected
                    }
                  >
                    Aspen
                  </Button>
                </td>

                {permissions.serverInfo && (
                  <td>
                    <Button
                      variant="text"
                      onClick={(e: any) => {
                        SetQueryType(QueryTypes.ServerInfo);
                      }}
                      className={
                        queryType == QueryTypes.ServerInfo
                          ? classes.buttonSelected
                          : classes.buttonUnSelected
                      }
                    >
                      Server Info
                    </Button>
                  </td>
                )}

                <td>
                  <Badge
                    badgeContent={data.csiAlerts + aspenAlerts}
                    color="warning"
                  >
                    <Button
                      variant="text"
                      onClick={(e: any) => {
                        SetQueryType(QueryTypes.Alerts);
                      }}
                      className={
                        queryType == QueryTypes.Alerts
                          ? classes.buttonSelected
                          : classes.buttonUnSelected
                      }
                    >
                      Alerts
                    </Button>
                  </Badge>
                </td>

                <td style={{ paddingLeft: "20px" }}>
                  <Fab
                    size="small"
                    color="primary"
                    aria-label="add"
                    onClick={(event) => {
                      HandleMoreClick(event);
                    }}
                  >
                    <MoreVertIcon />
                  </Fab>
                </td>
              </tr>
            </table>
          </Box>
        </Toolbar>
      </AppBar>

      {/* -------------------------- Dashboard Tab -------------------------- */}
      {queryType == QueryTypes.Dashboard && <Dashboard />}

      {/* -------------------------- Admin Tab -------------------------- */}
      {permissions.management && queryType == QueryTypes.Admin && (
        <NewInstance />
      )}

      {/* -------------------------- Ideal Customer Tab -------------------------- */}
      {permissions.idealCustomer && queryType == QueryTypes.Ideal && (
        <CustomerList
          handleCustomerListCallBack={handleCustomerListCallBack}
          search={searchdata}
          queryType={queryType}
        />
      )}

      {/* -------------------------- Infinity Customer Tab -------------------------- */}
      {permissions.infinityCustomer && queryType == QueryTypes.Infinity && (
        <CustomerList
          handleCustomerListCallBack={handleCustomerListCallBack}
          search={searchdata}
          queryType={queryType}
        />
      )}

      {/* -------------------------- Aspen Tab -------------------------- */}
      {queryType == QueryTypes.Aspen && <Aspen search={searchdata} />}

      {/* -------------------------- ServerInfo Tab -------------------------- */}
      {permissions.serverInfo && queryType == QueryTypes.ServerInfo && (
        <ServerInfo queryType={queryType} />
      )}

      {/* -------------------------- Alerts Tab -------------------------- */}
      {queryType == QueryTypes.Alerts && (
        <Alerts SetAspenAlerts={SetAspenAlerts} />
      )}

      {/* -------------------------- About Tab -------------------------- */}
      {queryType == QueryTypes.About && <About />}

      {/* -------------------------- Errors -------------------------- */}
      {permissions.errors && queryType == QueryTypes.Errors && <Errors />}

      {/* -------------------------- Communication Tab -------------------------- */}
      {queryType == QueryTypes.Communication && <Communication />}

      {/* -------------------------- Availiability Tab -------------------------- */}
      {queryType == QueryTypes.Availiability && (
        <Availability search={searchdata} queryType={queryType}></Availability>
      )}

      {/* -------------------------- Everest -------------------------- */}
      {queryType == QueryTypes.Everest && (
        <EverestMain search={searchdata} DefaultSearch={DefaultSearch} />
      )}
      {/* -------------------------- Everest -------------------------- */}
      {queryType == QueryTypes.Target && (
        <TargetMain search={searchdata} DefaultSearch={DefaultSearch} />
      )}

      {/* -------------------------- Csystems -------------------------- */}
      {queryType == QueryTypes.Csystems && (
        <CsystemsMain
          handleCustomerListCallBack={handleCustomerListCallBack}
          search={searchdata}
          queryType={queryType}
        ></CsystemsMain>
      )}

      {/* -------------------------- More Menu -------------------------- */}
      <Menu
        id="basic-menu"
        anchorEl={anchorElMore}
        open={anchorElMore != null}
        onClose={HideMore}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem
          onClick={(e: any) => {
            SetQueryType(QueryTypes.About);
            HideMore();
          }}
        >
          About
        </MenuItem>

        {permissions.errors && (
          <MenuItem
            onClick={(e: any) => {
              SetQueryType(QueryTypes.Errors);
              HideMore();
            }}
          >
            Error
          </MenuItem>
        )}

        <MenuItem
          onClick={(e: any) => {
            SetQueryType(QueryTypes.Communication);
            HideMore();
          }}
        >
          Communication
        </MenuItem>

        <MenuItem
          onClick={(e: any) => {
            SetQueryType(QueryTypes.Availiability);
            HideMore();
          }}
        >
          Availibility
        </MenuItem>

        <MenuItem
          onClick={(e: any) => {
            SetQueryType(QueryTypes.Everest);
            HideMore();
          }}
        >
          Everest
        </MenuItem>
        <MenuItem
          onClick={(e: any) => {
            SetQueryType(QueryTypes.Target);
            HideMore();
          }}
        >
          Target
        </MenuItem>

        <Divider />
        <MenuItem onClick={OnLogoutClick}>
          Logout (<span style={{ fontSize: "13px" }}> {username} </span>)
        </MenuItem>
      </Menu>

      <Popover
        open={showUserInfo}
        anchorEl={anchorEl}
        // onClose={handleCloseOrderDetail}
        onClose={(event: any) => SetShowUserInfo(false)}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box style={{padding:"10px"}}>
          <Box>
            Name: {domainUser.FullName}
          </Box>
          <Box>
            Phone: {domainUser.Phone}
          </Box>
          <Box>
            Email {domainUser.Email}
          </Box>
          <Box>
            User: {domainUser.DOMain}\{domainUser.UserName}
          </Box>
        </Box>
      </Popover>
    </Box>
  );
};
export default CSIMain;
